<template>
  <div class="custom-time-picker">
    
    <a-select
      :getPopupContainer="(triggerNode) => triggerNode.parentNode"
      :value="selectedHour"
      @change="onHourChange"
      show-search
      :filter-option="filterOption"
      placeholder="03"
      :disabled="disabled"
      style="min-width: 80px; width: fit-content"
      not-found-content="Tiempo incorrecto"
    >
      <template #suffixIcon><ClockCircleOutlined class="ant-select-suffix" /></template>
      <a-select-option v-for="hour in hours" :key="hour" :value="hour">
        {{ hour }}
      </a-select-option>
    </a-select>
    <span style="margin-right: 20px">Horas</span>
    <!-- <time-picker-type
      v-model:value="selectedMinute"
      :format="'mm'"
      :show-now="false"
      :placeholder="'Seleccionar minutos'"
    /> -->

    <a-select
      :getPopupContainer="(triggerNode) => triggerNode.parentNode"
      :value="selectedMinute"
      @change="onMinuteChange"
      show-search
      :filter-option="filterOption"
      placeholder="30"
      :disabled="disabled"
      style="min-width: 80px; width: 80px"
      not-found-content="Tiempo incorrecto"
    >
      <template #suffixIcon><ClockCircleOutlined class="ant-select-suffix" /></template>
      <a-select-option v-for="minute in minutes" :key="minute" :value="minute">
        {{ minute }}
      </a-select-option>
    </a-select>
    <span>Minutos</span>
  </div>
</template>

<script setup>
import { ref, watch, computed } from "vue";
import dayjs from "dayjs";
import { ClockCircleOutlined } from "@ant-design/icons-vue";

const props = defineProps({
  value: {
    type: [String, null],
    default: "",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:value"]);

const MAX_HOURS = 168;

const selectedHour = ref("00");
const selectedMinute = ref("00");
const hours = Array.from({ length: MAX_HOURS + 1 }, (_, i) => String(i).padStart(2, "0"));
// const minutes = Array.from({ length: 60 }, (_, i) => String(i).padStart(2, "0"));
const minutes = computed(() => {
  console.log(Number(selectedHour.value), 'Number(selectedHour.value) ');
  if (Number(selectedHour.value) < MAX_HOURS)
    return Array.from({ length: 60 }, (_, i) => String(i).padStart(2, "0"));
  else
    return ["00"];
});

// const hours = Array.from({ length: 72 }, (_, i) => i);
// const minutes = Array.from({ length: 60 }, (_, i) => i);

const filterOption = (input, option) => {
  return option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0;
};

const updateFormattedTime = () => {
  const hour = selectedHour.value;
  // const formattedHour = hour < 10 ? `0${hour}` : hour;
  const minute = selectedMinute.value;
  // const formattedMinute = minute < 10 ? `0${minute}` : minute;
  emit("update:value", `${hour}:${minute}:00`);
};

const onHourChange = (value) => {
  selectedHour.value = value;
  updateFormattedTime();
  if (Number(selectedHour.value) >= MAX_HOURS)
    selectedMinute.value = "00";
};

const onMinuteChange = (value) => {
  selectedMinute.value = value;
  updateFormattedTime();
};

watch(
  () => props.value,
  (newVal) => {
    if (newVal) {
      const [hour, minute] = newVal.split(":");
      selectedHour.value = hour;
      selectedMinute.value = minute;
    } else {
      selectedHour.value = "00";
      selectedMinute.value = "00";
    }
  },
  { immediate: true }
);
</script>

<style scoped lang="sass">
.custom-time-picker
  display: flex
  width: 160px
  gap: 10px
  align-items: center
</style>
